var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowOrangeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 45,
    viewBox: "0 0 19 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 8090"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.635076 10.0672L16.1813 22.4457C16.1813 22.4457 22.1777 17.6711 15.8468 12.6301C13.8884 11.0708 5.91408 4.72135 0.475098 0.390625L0.635076 10.0672Z",
    fill: "#F05831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0.635061 34.8238L16.1813 22.4453C16.1813 22.4453 22.1777 27.2199 15.8468 32.2608C13.8883 33.8202 5.91408 40.1696 0.475098 44.5003L0.635061 34.8238Z",
    fill: "#F05831"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowOrangeIcon);
export default __webpack_public_path__ + "static/media/arrow-orange-icon.ac69481fb0c3a4a52adc205e3ab93957.svg";
export { ForwardRef as ReactComponent };